(() => {
  const root = document.querySelector('[data-welcome-root]');
  if (!root) return;
  const dialog = root.querySelector('[data-welcome-dialog]');
  const teaser = root.querySelector('[data-welcome-open]');
  const preview = root.dataset.previewAllowed === 'true' && new URLSearchParams(location.search).get('welcome_preview') === '1';
  const ready = root.dataset.enabled === 'true' && root.dataset.emailReady === 'true';
  if (!ready && !preview) return;
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const save = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
  let previousFocus;
  const open = () => { if (dialog.open) return; previousFocus = document.activeElement; dialog.showModal(); document.documentElement.classList.add('welcome-is-open'); };
  const close = () => { dialog.close(); document.documentElement.classList.remove('welcome-is-open'); save('lt-welcome-dismissed', String(Date.now())); previousFocus?.focus(); };
  root.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', close));
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); } });
  teaser.addEventListener('click', open);
  root.querySelector('.welcome-form').addEventListener('submit', () => { dialog.close(); document.documentElement.classList.remove('welcome-is-open'); });
  const success = root.querySelector('[data-welcome-success]');
  if (success) { save('lt-welcome-subscribed', 'yes'); open(); return; }
  if (root.querySelector('[data-welcome-error]')) { open(); return; }
  if (preview) { open(); return; }
  if (read('lt-welcome-subscribed') === 'yes') return;
  teaser.hidden = location.pathname.startsWith('/cart');
  const dismissed = Number(read('lt-welcome-dismissed') || 0);
  if (Date.now() - dismissed > 7 * 24 * 60 * 60 * 1000 && !location.pathname.startsWith('/cart')) setTimeout(open, 7000);
})();
